<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <div class="view_cont">
                <dl class="view_subject">
                    <dt class="subject qna_view">
                        <em class="textcolor_urgent" v-if="'Y' === question.urgentYn"
                            >[{{ $t('FIELD.GLOBAL.URGENT') }}]</em
                        >{{ question.title }}
                        <span class="in_date">{{ question.regDt }}</span>
                    </dt>
                </dl>

                <!-- //reply -->
                <dl
                    class="commentWrite_wrap"
                    v-if="['ACP', 'PRO'].includes(result.FLOW_STATUS) && 0 < commentList.length"
                >
                    <dt>
                        <!-- {{ $t('MESSAGE.QNA.WANT') }} ({{ question.regUserNm }}, [SETK]) {{ $t('MESSAGE.QNA.BEFORE') }}? -->
                        {{ $t('MESSAGE.QNA.WANT') }} ({{ question.regUserNm }}) {{ $t('MESSAGE.QNA.BEFORE') }}?
                    </dt>
                    <div class="view_qna_desc" v-if="'PRO' === result.FLOW_STATUS">
                        <dl
                            :class="'Y' === reply.ANSWERER_YN ? '' : 'reply'"
                            v-for="reply in commentList"
                            :key="pageName + reply.QUESTION_FLOW_ID + reply.COMMENT_SEQ"
                        >
                            <dt>
                                <span class="item_status" v-if="'Y' === reply.ANSWERER_YN">
                                    {{ $t('MESSAGE.QNA.EXP.ANS') }}
                                </span>
                                <span class="item_name">{{ reply.REG_USER_NAME }}</span>
                                <span class="item_date">{{ reply.REG_DT }}</span>
                            </dt>
                            <dd>
                                <span v-html="getMessage(reply.MESSAGE)"></span>
                                <span class="in_btn_wrap">
                                    <a
                                        href="javascript:"
                                        class="btn_sm_white"
                                        v-if="!isMobile()"
                                        @click="translationPop(reply.MESSAGE)"
                                    >
                                        {{ $t('FIELD.GLOBAL.TRANSLATION') }}
                                    </a>
                                </span>
                            </dd>
                        </dl>
                        <!-- reply -->
                        <dl class="reply_write_wrap reply" v-if="'PRO' === result.FLOW_STATUS">
                            <dt data-input-type="textarea">
                                <textarea class="textarea_ty w100p" maxlength="3000" v-model="comment"></textarea>
                                <span class="textarea_counter">{{ commentLength }}/3000</span>
                            </dt>
                            <dd>
                                <a href="javascript:" class="btn_reply" @click="replyComment('replyComment')">
                                    {{ $t('BUTTON.MYKNOWLEDGE.REPLY') }}
                                </a>
                            </dd>
                        </dl>
                    </div>
                </dl>
                <!-- //reply -->
                <div
                    class="view_qna_desc"
                    v-if="!isNull(proSolution.ANSID) && !['ACP', 'PRO'].includes(result.FLOW_STATUS)"
                >
                    <dl>
                        <dt>
                            <span class="item_status">{{ $t('MESSAGE.QNA.EXP.ANS') }}</span>
                            <span class="item_name">{{ proSolution.ANSUSERNAME }}</span>
                            <span class="item_date">{{ proSolution.ANSDT }}</span>
                            <span v-if="'N' === question.openYn">
                                <em class="ico_lock"><span class="sr_only">lock</span></em>
                            </span>
                        </dt>
                        <dd>
                            <div class="namo_scrollbar" v-html="stripHtml(proSolution.ANSDESC)"></div>
                            <span class="in_btn_wrap">
                                <a href="javascript:" class="btn_sm_white" @click="translationPop('solution')">
                                    {{ $t('FIELD.GLOBAL.TRANSLATION') }}
                                </a>
                            </span>
                            <article class="attach_wrap" v-if="0 < proSolutionAttach.length">
                                <span class="sub_title">{{ $t('FIELD.GLOBAL.ATTACHMENT') }}</span>
                                <span class="modul">
                                    <innorix-download
                                        v-if="solutionView"
                                        uploadId="proSolution"
                                        :attachList="proSolutionAttach"
                                        :serviceType="serviceType"
                                    />
                                    <!-- 2020/08/05 김남갑 추가 -->
                                </span>
                                <dl class="attachment_link" v-if="proSolutionAttach.length > 0">
                                    <span>
                                        <a href="javascript:" class="txt_link" @click="toggleLink($event)">
                                            Having trouble downloading?
                                        </a>
                                    </span>
                                    <dd>
                                        <ul>
                                            <li
                                                v-for="file in proSolutionAttach"
                                                :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN"
                                            >
                                                <a
                                                    href="javascript:"
                                                    @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)"
                                                    class="txt_link"
                                                >
                                                    <span class="ico_attach"></span> {{ file.FILE_NM }}
                                                </a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                            </article>
                        </dd>
                    </dl>
                </div>
                <!-- See the Question -->
                <section
                    :class="
                        !isNull(proSolution.ANSDESC) || 'PRO' === result.FLOW_STATUS
                            ? 'see_question_wrap'
                            : 'view_question'
                    "
                >
                    <p class="sec_title" v-if="!isNull(proSolution.ANSDESC) || 'PRO' === result.FLOW_STATUS">
                        <em>{{ $t('FIELD.GLOBAL.QNA.SEE') }}</em>
                    </p>
                    <dl class="dl_view" v-if="!isNull(question.ascAccount)">
                        <dt>{{ $t('FIELD.USER.ACCOUNT.NO') }}</dt>
                        <dd>{{ question.ascAccount }}</dd>
                    </dl>
                    <dl class="dl_view" v-if="!isNull(question.questionId)">
                        <dt>{{ $t('FIELD.GLOBAL.QUESTION.ID') }}</dt>
                        <dd>{{ question.questionId }}</dd>
                    </dl>
                    <dl class="dl_view" v-if="!isNull(question.inquiryTypeNm)">
                        <dt>{{ $t('FIELD.GLOBAL.INQUIRY') }}</dt>
                        <dd>{{ question.inquiryTypeNm }}</dd>
                    </dl>
                    <dl class="dl_view" v-if="!isNull(question.modelCd)">
                        <dt>{{ $t('FIELD.GLOBAL.MODEL') }}</dt>
                        <dd>{{ question.modelCd }}</dd>
                    </dl>
                    <dl class="dl_view" v-if="!isNull(question.prdCategoryNm)">
                        <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                        <dd>{{ question.prdCategoryNm }}</dd>
                    </dl>
                    <dl class="dl_view" v-if="!isNull(question.repairType) || !isNull(question.serialNumber)">
                        <dt v-if="!isNull(question.repairType)">{{ $t('FIELD.QNA.REPAIR.TYPE') }}</dt>
                        <dd v-if="!isNull(question.repairType)">{{ question.repairType }}</dd>
                        <dt v-if="!isNull(question.serialNumber)">{{ $t('FIELD.QNA.SERIAL.NUMBER') }}</dt>
                        <dd v-if="!isNull(question.serialNumber)">{{ question.serialNumber }}</dd>
                    </dl>
                    <dl class="dl_view" v-if="!isNull(question.partsNumber) || !isNull(question.partsName)">
                        <dt v-if="!isNull(question.partsNumber)">{{ $t('FIELD.MYKNOWLEDGE.PARTS.NUMBER') }}</dt>
                        <dd v-if="!isNull(question.partsNumber)">{{ question.partsNumber }}</dd>
                        <dt v-if="!isNull(question.partsName)">{{ $t('FIELD.MYKNOWLEDGE.PARTS.NAME') }}</dt>
                        <dd v-if="!isNull(question.partsName)">{{ question.partsName }}</dd>
                    </dl>
                    <dl class="dl_view" v-if="!isNull(question.svcOrder) || !isNull(question.mckImei)">
                        <dt v-if="!isNull(question.svcOrder)">{{ $t('FIELD.QNA.SVC.ORDER') }}</dt>
                        <dd v-if="!isNull(question.svcOrder)">{{ question.svcOrder }}</dd>
                        <dt v-if="!isNull(question.mckImei)">{{ $t('FIELD.MYKNOWLEDGE.IMEI') }}</dt>
                        <dd v-if="!isNull(question.mckImei)">{{ question.mckImei }}</dd>
                    </dl>
                    <dl class="dl_view" v-if="!isNull(question.requiredDt)">
                        <dt>{{ $t('FIELD.GLOBAL.ANSWER.REQUIRED.DATE') }}</dt>
                        <dd>{{ question.requiredDt }}</dd>
                    </dl>
                    <dl class="dl_view" v-if="!isNull(question.questionDesc)">
                        <dt>{{ $t('FIELD.GLOBAL.QNA.DESC') }}</dt>
                        <dd>
                            <div class="namo_scrollbar" v-html="stripHtml(question.questionDesc)"></div>
                            <span class="in_btn_wrap">
                                <a href="javascript:" class="btn_sm_white" @click="translationPop('question')">
                                    {{ $t('FIELD.GLOBAL.TRANSLATION') }}
                                </a>
                            </span>
                        </dd>
                    </dl>
                    <dl class="dl_view" v-if="0 < questionAttach.length">
                        <dt>{{ $t('FIELD.GLOBAL.ATTACHMENT') }}</dt>
                        <dd>
                            <innorix-download
                                v-if="questionView"
                                uploadId="question"
                                :attachList="questionAttach"
                                :serviceType="serviceType"
                            />
                            <!-- 2020/08/05 김남갑 추가 -->
                            <dl class="attachment_link" v-if="questionAttach.length > 0">
                                <span>
                                    <a href="javascript:" class="txt_link" @click="toggleLink($event)">
                                        Having trouble downloading?
                                    </a>
                                </span>
                                <dd>
                                    <ul>
                                        <li
                                            v-for="file in questionAttach"
                                            :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN"
                                        >
                                            <a
                                                href="javascript:"
                                                @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)"
                                                class="txt_link"
                                            >
                                                <span class="ico_attach"></span> {{ file.FILE_NM }}
                                            </a>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </dd>
                    </dl>
                    <dl
                        class="dl_view"
                        v-if="!isMobile() && (!isNull(question.preQuestionId) || !isNull(question.nextQuestionId))"
                    >
                        <dt>{{ $t('SUBTITLE.QNA.QUESTION.HISTORY') }}</dt>
                        <dd>
                            <table class="data_table_ty2">
                                <colgroup>
                                    <col width="180px" />
                                    <col width="" />
                                    <col width="135px" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{ $t('FIELD.FAST.STATUS') }}</th>
                                        <th>{{ $t('FIELD.GLOBAL.SUBJECT') }}</th>
                                        <th>{{ $t('FIELD.GLOBAL.DATE') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="!isNull(question.preQuestionId)">
                                        <td>{{ $t('FIELD.GLOBAL.QNA.PRE') }}</td>
                                        <td class="text_center">
                                            <a
                                                href="javascript:"
                                                class="underline"
                                                @click="pageMove('questionDetail', question.preQuestionId)"
                                                >{{ question.preTitle }}</a
                                            >
                                        </td>
                                        <td class="text_center">{{ question.preRegDt }}</td>
                                    </tr>
                                    <tr v-if="!isNull(question.nextQuestionId)">
                                        <td>{{ $t('FIELD.GLOBAL.QNA.NEXT') }}</td>
                                        <td class="text_center">
                                            <a
                                                href="javascript:"
                                                class="underline"
                                                @click="pageMove('questionDetail', question.nextQuestionId)"
                                                >{{ question.nextTitle }}</a
                                            >
                                        </td>
                                        <td class="text_center">{{ question.nextRegDt }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </dd>
                    </dl>
                </section>
                <!-- //See the Question -->
                <div class="btn_wrap_full topLine">
                    <a
                        href="javascript:"
                        class="btn_blue  size_full"
                        v-if="question.regUserNo === loginNo && 'ANS' === this.flowStatus && isMobile()"
                        @click="evaluateQuestion('closeQuestion', question.questionId)"
                    >
                        {{ $t('BUTTON.QNA.CLOSE') }}
                    </a>
                    <a href="javascript:" class="btn_white size_full" @click="pageMove('questionList')">
                        {{ $t('BUTTON.GLOBAL.LIST') }}
                    </a>
                    <div class="btn_right pc_only">
                        <a
                            href="javascript:"
                            class="btn_white"
                            v-if="
                                question.regUserNo === loginNo &&
                                    (('2' === flowSeq && 'WFA' === flowStatus) || 'DRA' === question.qnaStatus)
                            "
                            @click="pageMove('createNewQuestion', question.questionId)"
                        >
                            {{ $t('BUTTON.GLOBAL.EDIT') }}
                        </a>
                        <a
                            href="javascript:"
                            class="btn_white"
                            v-if="
                                question.regUserNo === loginNo &&
                                    (('2' === flowSeq && 'WFA' === flowStatus) || 'DRA' === question.qnaStatus)
                            "
                            @click="deleteQuestion(question.questionId)"
                        >
                            {{ $t('BUTTON.GLOBAL.DELETE') }}
                        </a>
                        <a
                            href="javascript:"
                            class="btn_white"
                            v-if="
                                question.regUserNo === loginNo && 'ANS' === this.flowStatus && !question.nextQuestionId
                            "
                            @click="evaluateQuestion('reQuestion', question.questionId)"
                        >
                            {{ $t('BUTTON.QNA.ASK.AGAIN') }}
                        </a>
                        <a
                            href="javascript:"
                            class="btn_blue"
                            v-if="question.regUserNo === loginNo && 'ANS' === this.flowStatus"
                            @click="evaluateQuestion('closeQuestion', question.questionId)"
                        >
                            {{ $t('BUTTON.QNA.CLOSE') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import { EventBus } from '@/utils/EventBus';
import { SDLUtil, DateUtil, StringUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

import userListPopup from '~vb/faq/popup/userListPopup';
import commentPopup from '~vb/faq/popup/commentPopup';
import communicationPopup from '~vb/faq/popup/communicationPopup';
import evaluatePopup from '~vb/faq/popup/evaluatePopup';
import TransPopup from '~c/popup/TransPopup';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import CrossEditor from '~c/CrossEditor';
import InnorixDownload from '~c/InnorixDownload';

require('moment-jdateformatparser');

export default {
    name: 'questionDetail',
    components: {
        'cross-editor': CrossEditor,
        'innorix-download': InnorixDownload,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    props: {
        searchKey: '',
    },
    computed: {
        ...mapGetters({
            loginSystem: 'getLoginSystem',
            menus: 'getMenus',
            loginNo: 'getLoginNo',
        }),
        getQuestionId() {
            let questionId = (this.$route.query.questionId || '').trim();
            return questionId;
        },
    },
    data() {
        return {
            pageName: 'questionDetail',
            pageTitle: '',
            questionId: '',
            result: {},
            question: {},
            proSolution: {},
            flowSeq: '',
            flowStatus: '',
            questionAttach: [],
            proSolutionAttach: [],
            serviceType: 'common',
            comment: '',
            commentLength: 0,
            commentList: [],
            openYn: 'N',
            isMobile: SDLUtil.isMobile,
            questionView: false,
            solutionView: false,
        };
    },
    mounted() {
        EventBus.$on('question-detail-user-popup', param => {
            this.userListPopup(param);
        });
        EventBus.$on('question-detail-user-popup-comment', param => {
            this.commentPopup(param);
        });
        EventBus.$on('question-detail-user-popup-communication', param => {
            this.communicationPopup(param);
        });

        if (SDLUtil.isNull(this.searchKey)) {
            this.searchList(this.getQuestionId);
        } else {
            this.searchList(this.searchKey);
        }

        window.setTimeout(() => {
            this.questionView = true;
            window.setTimeout(() => {
                this.solutionView = true;
            }, 1000);
        }, 1000);
    },
    watch: {
        comment() {
            this.commentLength = SDLUtil.textLength(this.comment);
        },
    },
    methods: {
        async searchList(v) {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionDetailView.skp`,
                    qs.stringify({
                        systemId: this.loginSystem,
                        questionId: v,
                    }),
                )
                .then(resp => {
                    for (const result of resp.data.result.rowData) {
                        this.result = result;
                    }
                    this.question = resp.data.question;
                    // 2020/08/05 김남갑 추가
                    this.question.title = SDLUtil.convertHtml(this.question.title);
                    this.questionAttach = resp.data.attach.rowData;
                    for (const solution of resp.data.proAnswer.rowData) {
                        this.proSolution = solution;
                    }

                    this.proSolutionAttach = resp.data.proAttach.rowData;
                    this.flowSeq = resp.data.flowSeq;
                    this.flowStatus = resp.data.flowStatus;

                    this.commentList = resp.data.commentList.rowData;
                    this.questionId = v;
                    this.openYn = this.question.openYn;

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        menuCommit(menu, subMenu, connUrl) {
            for (const menus of this.menus) {
                if (menu === menus.menuNm) {
                    for (const menu of menus.subMenu) {
                        if (subMenu === menu.menuNm) {
                            store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                            if (SDLUtil.isNull(connUrl)) {
                                connUrl = menu.connUrl.replace('.skp', '');
                            }
                            return connUrl;
                        }
                    }
                }
            }
        },
        isNull(v) {
            return SDLUtil.isNull(v);
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        translationPop(v) {
            let translation = '';
            if ('question' === v) {
                translation = StringUtil.removeHtmlTag(this.stripHtml(this.question.questionDesc));
            } else if ('solution' === v) {
                translation = StringUtil.removeHtmlTag(this.stripHtml(this.proSolution.ANSDESC));
            } else {
                translation = v;
            }
            SDLUtil.show(
                TransPopup,
                {
                    bodyText: translation,
                },
                { height: 'auto' },
            );
        },
        deleteQuestion(v) {
            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.REMOVE.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionDelete.skp`,
                            qs.stringify({ questionId: v }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            return this.pageMove('questionList');
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        evaluateQuestion(v, questionId) {
            SDLUtil.show(
                evaluatePopup,
                {
                    target: v,
                    questionId: questionId,
                    rtnFunc: (target, questionId) => {
                        this.closeQuestion(target, questionId);
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        closeQuestion(v, questionId) {
            if ('reQuestion' === v) {
                return this.pageMove('reQuestion', questionId);
            } else if ('closeQuestion' === v) {
                return this.pageMove('questionList');
            }
        },
        replyComment(v) {
            if (SDLUtil.isNull(this.comment)) return;
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/toAnswer/questionProcessing.skp`,
                    qs.stringify({
                        questionId: this.questionId,
                        questionFlowId: this.result.QUESTION_FLOW_ID,
                        comment: this.comment,
                        answererYn: 'N',
                        replyComment: v,
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    EventBus.$emit('question-snb-status');
                    this.searchList(this.questionId);
                    this.comment = '';
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        pageMove(tab, v) {
            if ('createNewQuestion' === tab && !SDLUtil.isNull(v)) {
                return this.$router.push({
                    path: this.menuCommit('Q&A', 'Create New Question', '/basis/qna/createNewQuestion'),
                    query: { questionId: SDLUtil.nvl(v) },
                });
            } else if ('reQuestion' === tab && !SDLUtil.isNull(v)) {
                return this.$router.push({
                    path: this.menuCommit('Q&A', 'Create New Question', '/basis/qna/createNewQuestion'),
                    query: { preQuestionId: SDLUtil.nvl(v) },
                });
            } else if ('questionDetail' === tab && !SDLUtil.isNull(v)) {
                return this.$router.push({
                    path: this.menuCommit('Q&A', 'Q&A List', '/skp/basis/myKnowledge/myQnA/myQuestion/questionDetail'),
                    query: { questionId: SDLUtil.nvl(v) },
                });
            } else {
                return this.$router.push(
                    this.menuCommit('Q&A', 'Q&A List', '/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionList'),
                );
            }
        },
        menuCommit(menu, subMenu, conUrl) {
            for (const menus of this.menus) {
                for (const menu of menus.subMenu) {
                    let connUrl = menu.connUrl.replace('.skp', '');
                    if (conUrl === connUrl) {
                        store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                        return connUrl;
                    }

                    if (
                        '/skp/basis/myKnowledge/myQnA/myQuestion/questionDetail' === conUrl &&
                        '/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionList' === connUrl
                    ) {
                        store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                        return conUrl;
                    }

                    if ('/basis/qna/createNewQuestion' === conUrl && '/basis/qna/newQuestionList' === connUrl) {
                        store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                        return conUrl;
                    }
                }
            }

            return MenuUtil.getSupportMain();
        },
        userListPopup(param) {
            SDLUtil.show(
                userListPopup,
                {
                    param,
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        commentPopup(param) {
            SDLUtil.show(
                commentPopup,
                {
                    param,
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        communicationPopup(param) {
            SDLUtil.show(
                communicationPopup,
                {
                    param,
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        getMessage(v) {
            if (!SDLUtil.isNull(v)) {
                v = v.replace(/\n/g, '<br />');
            }

            return v;
        },
        // 2020/08/05 김남갑 추가
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return window.open(cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN);
        },
        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },
    },
    beforeDestroy() {
        EventBus.$off('question-detail-user-popup');
        EventBus.$off('question-detail-user-popup-comment');
        EventBus.$off('question-detail-user-popup-communication');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/qna/questionDetail.vue